define('commons/accordion-filter',['jquery', 'commons/filter-form', 'commons/draggable-elements', 'commons/loading-mask', 'commons/request-parser', 'commons/ui-element-introduction', 'commons/message-manager', 'commons/save-search-widget', 'commons/flat-tree-popup','commons/flat-tree', 'jquery-deserialize',  'formatDateTime'], 
        function($, FilterForm, DraggableElements, LoadingMask, RequestParser, UIElementIntroduction, messages, SaveSearchWidget, FlatTreePopup, FlatTree) {
    
    /**
     * FilterForm with some new tools : default/additional fields if more than 'N' fields in the form. 
     * It also displays a human readable filter summary, and allows DnD with the fields.
     */
    var AccordionFilter = function(container, options) {
        this.container = $(container);
        this.containerId = container;
        this.accordionLoadingMask = new LoadingMask(container + ' div.filter-container');
        this.requestParser = this._createRequestParser();
        this.asyncLoading = $.Deferred();
        var options = $.extend({
            // Can be changed anytime, everything is carefully handled baby ;) just sit down and chill out
            defaultFieldsNb : 4,
            asyncLoadingHandler : function(promise) {
                if (promise.state() === "pending") {
                    promise.resolve();
                }
            },
            beforeSearchLoad : function(){},
            searchLoaded : function(){}
        }, options);
        
        // Binding, default fields retrieving and so on...
        this._init( options );
    }
    
    // Inherit from FilterForm
    for ( var element in FilterForm.prototype) {
        AccordionFilter.prototype[element] = FilterForm.prototype[element];
    }
    
    AccordionFilter.prototype._onFieldsLoaded = function( options ) {
        return function(){
            // Call the inherited filter form constructor
            FilterForm.call(this, this.containerId, options);
            
            // DnD for all the fields
            this._enableDnD( options.beanName );
            
            setTimeout($.proxy(function(){
                this.accordionLoadingMask.hide();
                var introduction = new UIElementIntroduction( UIElementIntroduction.ELEMENT_KEYS.get('ACCORDION_FILTER'));
                introduction.runIfNeverSeen();
            },this),100);   
        };
    };
    
    /**
     * Creates the RequestParser to display the filter request in a user friendly way.
     * In a close future we could use this to send some stats about user requests (to create relevant indexes for instance)
     */
    AccordionFilter.prototype._createRequestParser = function() {
        var fieldDescriptionMap = {};
        var ajaxSelectMap = {};
        var i = 0;
        
        this.container.find('div[data-accordion-filter-id]').map(function(){
            var $this = $(this).clone();
            // hidden text
            $this.find('label .hidden').remove();

            var label = $this.find('label').text();
            var id = $this.data('accordion-filter-id');
            // optional (selects and special fields (e.g. average rssi) )
            var defaultValue = $this.data('default-value');
            // optional ["fieldName1", "fieldName2" ...], ajax loaded <select>
            var ajaxSelects = $this.data('ajax-selects');
            // optional 
            var dynamicSelector = $this.data('input-selector');
            // optional (select only, for now)
            var values;
            // date format if any
            var dateFormat;
            
            // let's store ajaxSelect names if any
            if( ajaxSelects ){
                ajaxSelects = typeof templates === 'string' ? JSON.parse(ajaxSelects) : ajaxSelects; 
                ajaxSelectMap[id] = [];
                for (var i = 0, length = ajaxSelects.length; i < length; i++) {
                    ajaxSelectMap[id].push(ajaxSelects[i]);
                }
            }
            
            if( $this.find('.date-picker').length > 0){
                dateFormat = 'MM d yy';
            } else if( $this.find('.date-time-picker').length > 0 ){
                dateFormat = "MM d yy 'at' hh:ii";
            }
            
            var options = $this.find('option');
            if( options.length > 0 ){
                values = {};
                options.map(function(){
                    var $option = $(this);
                    values[$option.val()] = $option.html();
                });
            }
            
            fieldDescriptionMap[id] = {
                    'label' : label,
                    'defaultValue' : defaultValue,
                    'values' : values,
                    'dateFormat' : dateFormat,
                    'dynamicInputSelector' : dynamicSelector
            };
        });
        
        return new RequestParser( fieldDescriptionMap, ajaxSelectMap );
    };
    
    /**
     * Attaches click handlers, and then loads defaults fields from DB if UserPrefs exists (takes the first N fields otherwise) 
     */
    AccordionFilter.prototype._init = function( options ) {
        this.accordionLoadingMask.show();
        var totalFieldsNb = this.container.find('div[data-accordion-filter-id]').length;
  
        this.container.find('button#show-more').removeClass('hidden');
        this.container.find('button#show-more').on('click', $.proxy(this._showMoreHandler, this));
        this.container.find('#filter-description').on('click', $.proxy(this._showMoreHandler, this));
        this.container.find('#filter-description').addClass('enabled');
 
        // Swap default nodes with nodes selected by user (if existing)
        this._loadDefaultFields( options.beanName, 
                options.defaultFieldsNb,
                $.proxy(this._onFieldsLoaded(options), this));
        
        this._addSearchCRUD( options.beanName );
        
        this.ignoredFieldsNames = this.container.find('[data-no-reset="true"]').map( function(index, elem){
            return elem['name'];
        }).get();
    };
    
    AccordionFilter.prototype._addSearchCRUD = function ( beanName ) {
        this._addSearchDelete(beanName);
        this._addSearchSave(beanName);
        this._addSearchLoad(beanName);
    };

        
    AccordionFilter.prototype._addSearchDelete = function(beanName) {
        var toBeDeleted = [];
        var here = this;
        
        var onCheckboxChange = function(event) {
            if( $(this).is(':checked') ){
                toBeDeleted.push($(this).data('itemInfo').id);
            } else{
                var index = toBeDeleted.indexOf($(this).data('itemInfo').id);
                toBeDeleted.splice(index, 1);
            }
        };

        this.searchesList = new FlatTreePopup(here.containerId + ' #delete-search-btn', {
            title : 'Delete the selected searches',
            height : 520,
            open: function( event, ui ) {
                toBeDeleted = [];
            },
            buttons : {
                'Cancel' : function() {
                    $(this).dialog('close');
                },
                'Delete' : function() {
                    here._deleteSearchHandler(toBeDeleted);
                    $(this).dialog('close');
                }
            }
        }, {
            reset : true,
            createTree : function(container) {
                return new FlatTree(container, {
                    autoLoad : false,
                    nbPanels : 1,
                    loadItemUrl : '/userPrefs/json/searches/' + beanName,
                    createItem : function(item) {
                        item.isLeaf = true;
                        return {
                            id : item.id,
                            text : item.name,
                            checkbox : {
                                events : {
                                    'change' : onCheckboxChange
                                }
                            }
                        };
                    }
                });
            }
        });
    };
    
    AccordionFilter.prototype._addSearchSave = function (beanName) {
        new SaveSearchWidget(this.containerId + ' #save-search-btn', beanName, $.proxy(this._saveSearchHandler, this));
    };
    
    AccordionFilter.prototype._addSearchLoad = function (beanName) {
        var here = this;
        var closeAndLoadSearch = function (event){
            here._loadSearchHandler( $(this).data('itemInfo') );
            here.searchesList.dialogSelector.dialog('close');
        };
        
        this.searchesList = new FlatTreePopup( here.containerId + ' #load-search-btn', {title : 'Select the search to load'}, {
            reset : true,
            createTree: function(container) {
                return new FlatTree(container, {
                    autoLoad: false,
                    nbPanels: 1,
                    loadItemUrl : '/userPrefs/json/searches/' + beanName,
                    createItem: function(item) {
                        item.isLeaf = true;
                        return {
                            id : item.id,
                            text: item.name,
                            link: true,
                            events: {
                                'click' : closeAndLoadSearch,
                            }
                        };
                    }
                });
            }
        });
    };
    
    
    AccordionFilter.prototype._loadDefaultFields = function ( beanName, defaultFieldsNb, onFieldsLoaded ) {
        // Ajax call to retrieve user prefs (if any)
        var container = this.container;
        $.ajax({
            type: 'GET',
            url: '/userPrefs/json/default/filter/fields/list',
            data: 'beanName=' + beanName,
            success: function(data) {
                var defaultIds;
                var $defaultFields = container.find('div#default-fields');

                // Values in DB ?
                if(data && data.length > 0){
                    var i = data.length;
                    while (i--) {
                        if( data[i] && container.find('div[data-accordion-filter-id=' + data[i] + ']').length > 0 ){
                            $defaultFields.append( container.find('div[data-accordion-filter-id=' + data[i] + ']') );
                        }else{
                            // not enough keys in DB, we pick the first additional field 
                            // It could happen if we change the default fields nb
                            var $div = container.find('div#additional-fields div[data-accordion-filter-id]:first-child');
                            $defaultFields.append($div);
                            // Let's remove it from default values
                            // If not, we could try to add this div again but it'd already be in the default panel
                            // so we'd miss a div
                            var index = data.indexOf($div.data('accordion-filter-id')); 
                            if (index !== -1) {
                                data.splice(index, 1);
                            }
                        }
                    }
                }else{
                    // first N fields (where N is the default fields nb)
                    var $firstFields = container.find('div[data-accordion-filter-id]:nth-of-type(-n+' + defaultFieldsNb + ')');
                    container.find('div#default-fields').append($firstFields);
                }
                
                // UserPref needs to be updated
                if( !data || data.length === 0 || data.length !== defaultFieldsNb ){
                    var defaultIds = $defaultFields.find('div[data-accordion-filter-id]').map(function(){
                        return $(this).data('accordion-filter-id');
                    }).get();

                    $.ajax({
                        type: 'POST',
                        url: '/userPrefs/edit/default-filter-fields',
                        contentType: 'application/json; charset=UTF-8',
                        data: JSON.stringify({'beanClass' : beanName, 'fields' : defaultIds.reverse() })
                    });
                }
                
                // Don't try to chosenify hidden select... believe me, you don't wanna see that...
                container.find('div#additional-fields select').addClass('accordion-ignore-chosen');
                
                onFieldsLoaded();
            }
        });
    };
    
    /**
     * DnD sh*t... not interesting at all 
     */
    AccordionFilter.prototype._enableDnD = function ( beanName ) {
        var here = this;
        here.container.find('div[data-accordion-filter-id] label').on('mouseenter', function(){
            $(this).parent().addClass('hovered'); 
            $(this).attr('draggable', 'true');
        }).on('mouseleave', function(){
            $(this).parent().removeClass('hovered');
            $(this).attr('draggable', 'false');
        });
        
        var $elements = here.container.find('div[data-accordion-filter-id]');
        var $dest = here.container.find('div#default-fields, div#additional-fields');
        var $dragSrc;
        
        new DraggableElements( $elements, $dest, {
            
            handleDragStart : function(context, $element){
                $dragSrc = $element;
                // Drop is forbidden in the additional fields div only when the source comes from the same div
                var parentId = $dragSrc.parent('div#default-fields,div#additional-fields').attr('id');
                here.container.find('div#' + parentId + ' div[data-accordion-filter-id!=' + $dragSrc.data('accordion-filter-id') +']').addClass('drop-not-allowed');
            },
            
            handleDragEnter : function(event){
                $('.dragOver').removeClass('dragOver');
            },
            
            handleDragOver : function(context, $element, onLeftSide){
                // No DnD inside the additional fields panel
                if( $dragSrc.parent('div#additional-fields,div#default-fields').attr('id') == $element.attr('id') ){
                    return;
                }
                $element.addClass('dragOver');
            },
            
            handleDragLeave : function(context, $element){
                $('.dragOver').removeClass('dragOver');
            },
            
            handleDragEnd : function(context, $element){
                $('.dragOver').removeClass('dragOver');
                here.container.find('div[data-accordion-filter-id]').removeClass('drop-not-allowed').removeClass(context.CONSTANTS.get('DRAGGING_CLASS'));
            },
            
            // The data we want to be transfered by DnD
            getDataTransferObject: function($element, isDropEvent) {
                if(isDropEvent){
                    return $element.closest('div#default-fields, div#additional-fields').attr('id');
                }
                return $element.data('accordion-filter-id');
            },

            // Start/End data, same type returned by getDataTransferObject above
            dataDropped: function(sourceData, destData) {
                if(sourceData && destData){
                    var $source = here.container.find('div[data-accordion-filter-id=' + sourceData + ']');
                    var $dest = here.container.find('div[id=' + destData + ']');
                    
                    // No swap between additional fields
                    if( $source.parent('div#additional-fields, div#default-fields').attr('id') == destData){
                        return;
                    }
                    
                    here._insertIn($source, $dest);
                    
                    var defaultFields = here.container.find('div#default-fields div[data-accordion-filter-id]').map(function(){
                        return $(this).data('accordion-filter-id');
                    }).get();
                    
                    $.ajax({
                        type: 'POST',
                        url: '/userPrefs/edit/default-filter-fields',
                        contentType: 'application/json; charset=UTF-8',
                        data: JSON.stringify({'beanClass' : beanName, 'fields' : defaultFields.reverse() })
                    });
                }
            }
        });
    };

    AccordionFilter.prototype.innerReset = function() {
        // Clear the current filter summary
        this.container.find('#filter-description').slideUp().empty();
        this.container.find('button#show-more span').removeClass('icon-chevron-up').addClass('icon-chevron-down');
    };

    AccordionFilter.prototype.requestForm = function(update, autoRefresh) {
        // Super call
        var here = this;
        FilterForm.prototype.requestForm.call(here, update, autoRefresh);
        var parsedRequest = here.requestParser.parse( here.container.serialize() );
        $moreFilters = here.container.find('.more-filters');
        
        if( $moreFilters.is(':visible') ){
            here.container.find('button#show-more span').removeClass('icon-chevron-up').addClass('icon-chevron-down');
        }
        
        $moreFilters.slideUp(function(){
            // Update the current filter summary
            if( parsedRequest ){
                here.container.find('#filter-description').html(parsedRequest).slideDown();
            } else{
                here.container.find('#filter-description').slideUp().empty();
            }
        });
    };
    
    /*******************************************
     *                  UTILS                  *
     ******************************************/

    AccordionFilter.prototype._deleteSearchHandler = function( searches ){
        $.ajax({
            type: 'POST',
            url: '/userPrefs/delete/searches/' + this.settings.beanName,
            data: JSON.stringify( searches ),
            contentType: 'application/json; charset=UTF-8',
            success:function(data){
                messages.info('Selected searches have been successfully deleted');
            }
        });
    };
    
    AccordionFilter.prototype._saveSearchHandler = function( itemInfo ){
        $.ajax({
            type: 'POST',
            url: '/userPrefs/edit/searches/' + this.settings.beanName,
            data: JSON.stringify({ name : itemInfo.text, id : itemInfo.id, parameters : this.container.serialize()}),
            contentType: 'application/json; charset=UTF-8',
            success:function(data){
                messages.info('Search has been successfully saved');
            },
            error:function(xhr){
                messages.error(xhr.statusText);
                throw new Error('An error occurred while saving a search: ' + xhr.statusText);
            }
        });
    };
    
    AccordionFilter.prototype._filterQuery = function (query) {
        if(this.ignoredFieldsNames.length == 0){
            return query;
        }
        // eZ one e.g. "myfield=myvalue&"
        var regEx = new RegExp( '(' + this.ignoredFieldsNames.join('|') + ")=[^&]*(&)?", 'gi' );
        // and the second to clear trailing '&' if any
        return query.replace( regEx, '').replace(/&$/g, '');
    };

    AccordionFilter.prototype._asyncLoadSearchHandler = function(itemInfo) {
        $.ajax({
            context : this,
            url: '/userPrefs/json/searches/' + this.settings.beanName + '/' + itemInfo.id,
            success:function(data){
                this.reset();

                //filter query to remove data-no-reset fields
                var filteredQuery = this._filterQuery(data.query);

                this.container.deserialize(filteredQuery, {
                    complete : $.proxy(function(){
                        this.settings.searchLoaded();

                        //----------- Update simple Date inputs -----------------
                        $('.date-picker').each(function(index,elem){
                            var elemVal = $('#' + elem.id + '-alt').val();
                            if( !elemVal ){
                                return;
                            }
                            var dateFormat = $(this).datepicker( 'option', 'dateFormat' );
                            $(this).datepicker('setDate', $.formatDateTime(dateFormat, new Date( elemVal )));
                        });

                        //----------- Update Date with Time inputs -----------------
                        $('.date-time-picker').each(function(index,elem){
                            var elemVal = $('#' + elem.id + '-alt').val();
                            if(!elemVal){
                                return;
                            }
                            var dateFormat = $(this).datepicker( 'option', 'dateFormat' );
                            // replace some original format letters because the formatDateTime plugin uses its own (sic) ...
                            var dateTimeFormat = $(this).datepicker( 'option', 'timeFormat' ).replace('HH', 'hh').replace('mm', 'ii');

                            $(this).datetimepicker('setDate', $.formatDateTime(dateFormat + ' ' + dateTimeFormat, new Date(unescape(elemVal).replace(/\+/g, ' '))));
                        });

                        //----------- Update custom selects -----------------
                        this.container.find('select').trigger('chosen:updated').trigger('change');

                        this.accordionLoadingMask.hide();
                        setTimeout($.proxy(function(){
                            this.container.submit();
                        },this),600);
                    },this)
                });
            },
            error:function(){
                messages.error('An error occurred : cannot load this search');
                here.accordionLoadingMask.hide();
            }
        });
    };

    AccordionFilter.prototype._loadSearchHandler = function( itemInfo ){
        this.accordionLoadingMask.show();
        this.settings.beforeSearchLoad.call(this);
        var asyncHandler = this.settings.asyncLoadingHandler;
        if (typeof asyncHandler === 'function' && this.asyncLoading.state() === 'pending') {
            $.when(this.asyncLoading.promise()).then($.proxy(function() {
                this._asyncLoadSearchHandler(itemInfo);
            }, this));
            // async load the form
            asyncHandler.call(this, this.asyncLoading);
        } else {
            this._asyncLoadSearchHandler(itemInfo);
        }
    };
    
    AccordionFilter.prototype._showMoreHandler = function(){
        var $icon = this.container.find('button#show-more span');
        
        // onOpen
        if( $icon.hasClass('icon-chevron-down') ){
            $icon.removeClass('icon-chevron-down').addClass('icon-chevron-up');
            this.stopAutoRefresh();
        }else{
            // onClose
            $icon.removeClass('icon-chevron-up').addClass('icon-chevron-down');
            if (this.settings.autoRefresh) {
                this.startAutoRefresh();
            }
        }
        
        this.container.find('.more-filters').slideToggle();
        this.container.find('div:visible[data-accordion-filter-id] select.hidden.accordion-ignore-chosen').removeClass('hidden accordion-ignore-chosen').chosen({
            disable_search_threshold: 7,
            allow_single_deselect: true,
            search_contains : true,
            no_results_text: 'Nothing found for '
        });
    };
    
    AccordionFilter.prototype._insertIn = function (a, b) {
        if(!a || !b){
            return;
        }
        b.append(a);
    };
    
    return AccordionFilter;
});
